export function removaPagamentosComValorZero(pagamentos: any): any {
  if(!Array.isArray(pagamentos)) return pagamentos;

  return pagamentos.filter((pagamento: any) => {
    if(pagamento?.id != null) return true;

    const valor = pagamento?.valor;

    if(typeof valor === 'number') return valor !== 0;
    if(typeof valor !== 'string' || !valor.trim()) return true;

    const valorNumerico = Number(valor.trim().replace(',', '.'));

    return !Number.isFinite(valorNumerico) || valorNumerico !== 0;
  });
}
